import React from 'react';
import { withRouter } from 'react-router-dom';

/* Material-UI Components */
import Button from '@material-ui/core/Button';

/* BCA Components */
import EquityForm from './components/EquityForm';
import InsuranceForm from './components/InsuranceForm';
import CashForm from './components/CashForm';
import ImmobilienForm from './components/ImmobilienForm';
import withNotification from '../NotificationProvider';
import BaseDialog from "../BaseDialog/BaseDialog";

/* BCA modules */
import useStyles from './styles';
import { ASSET_MODAL_TYPE } from './constants';


export default withNotification(withRouter((props) => {
  const classes = useStyles();

  const {
    asset,
    assetType,
    onModalClose,
  } = props;

  React.useEffect(() => {
    document.body.style.overflowY = asset ? 'hidden' : 'auto';
  }, [asset]);

  const handleModalClose = () => {
    if (onModalClose) {
      onModalClose();
    } 
  };

  const renderContent = () => {
    switch (assetType) {
      case ASSET_MODAL_TYPE.EQUITY: {
        return <EquityForm asset={asset} viewOnly/>
      }
      case ASSET_MODAL_TYPE.INSURANCE: {
        return <InsuranceForm asset={asset} viewOnly/>
      }
      case ASSET_MODAL_TYPE.CASH: {
        return <CashForm asset={asset} viewOnly/>
      }
      case ASSET_MODAL_TYPE.IMMOBILIEN: {
        return <ImmobilienForm asset={asset} viewOnly/>
      }
      default: {
        return null
      }
    }
  };

  return (
    <BaseDialog
      open={!!asset}
      handleClose={handleModalClose}
      maxWidth={'md'}
      title={'Anzeigen'}
      classes={
        {
          root: classes.root,
          paper: classes.paper
        }
      }
      customClasses={{dialogTitle: classes.modalTitle, dialogActions: classes.modalAction}}
      actions={
        <div>
          <Button onClick={handleModalClose} color="primary" className={classes.discardButton}>
            Schließen
          </Button>
        </div>
      }
    >
      <>
        {asset && assetType && renderContent()}
      </>
    </BaseDialog>
  );
}));